module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "box-color"
  }, [_c('input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": _vm.id,
      "type": "text"
    },
    domProps: {
      "value": this.value
    },
    on: {
      "change": function($event) {
        return _vm.onChange($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "view-color"
  })])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-e02ba01a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/ColorPicker.vue
 ** module id = 917
 ** module chunks = 1
 **/